import { useState } from 'react';
import LogoCizim from '../../../components/brand/LogoCizim';
import { logoUst } from '../../../components/brand/markaYollari';

interface NavigationProps {
  scrolled?: boolean;
}

export default function Navigation({ scrolled = false }: NavigationProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <LogoCizim src="/images/logo.webp" alt="Mahallebi" yol={logoUst} renk="#8C1427" className="h-12" />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('features')}
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              Neden Mahallebi?
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              Nasıl Çalışır?
            </button>
            <button
              onClick={() => scrollToSection('download')}
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              Keşfet
            </button>
            <a
              href="/esnaf"
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              Esnaf
            </a>
            <a
              href="/sss"
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              SSS
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#111827] hover:text-[#e77e23] transition-colors whitespace-nowrap cursor-pointer"
            >
              İletişim
            </button>
          </div>

          {/* Desktop CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="/app/"
              className="px-6 py-2.5 border-2 border-[#e77e23] text-[#e77e23] rounded-full hover:bg-[#e77e23] hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              Giriş Yap
            </a>
            <button
              onClick={() => scrollToSection('download')}
              className="px-6 py-2.5 bg-[#e77e23] text-white rounded-full hover:bg-[#d56d12] transition-all whitespace-nowrap cursor-pointer"
            >
              Uygulamayı İndir
            </button>
          </div>

          {/* Mobile Menu Button & Login */}
          <div className="flex lg:hidden items-center space-x-3">
            <a
              href="/app/"
              className="px-4 py-2.5 min-h-[44px] inline-flex items-center text-sm font-medium border-2 border-[#e77e23] text-[#e77e23] rounded-full hover:bg-[#e77e23] hover:text-white transition-all whitespace-nowrap cursor-pointer"
            >
              Giriş Yap
            </a>
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#111827] w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('features')}
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                Neden Mahallebi?
              </button>
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                Nasıl Çalışır?
              </button>
              <button
                onClick={() => scrollToSection('download')}
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                Keşfet
              </button>
              <a
                href="/esnaf"
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                Esnaf
              </a>
              <a
                href="/sss"
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                SSS
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-[#111827] hover:text-[#e77e23] transition-colors text-left cursor-pointer"
              >
                İletişim
              </button>
              <button
                onClick={() => scrollToSection('download')}
                className="px-6 py-2.5 bg-[#e77e23] text-white rounded-full hover:bg-[#d56d12] transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Uygulamayı İndir
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}